/**
 * Glow layers behind the locker illustration — electric-blue and royal
 * blurs. Also serves as the loading / no-WebGL fallback for the three.js
 * scene. (The old bottom "grounding fade" rectangle was removed: over the
 * full-bleed canvas it visibly dimmed a hard-edged box of the grid.)
 */
export const Background = () => {
  return (
    <>
      <div
        aria-hidden
        className="absolute left-[30px] top-[-25px] z-[751] h-[88px] w-[250px] rotate-[27.34deg] bg-ox-blue opacity-30 blur-[128px]"
      />
      <div
        aria-hidden
        className="absolute left-[5px] top-0 z-[751] h-[186px] w-[184px] -scale-x-100 bg-ox-blue opacity-20 blur-[150px]"
      />
      <div
        aria-hidden
        className="absolute left-[23px] top-[26px] h-[157px] w-[120px] rotate-90 bg-ox-royal blur-[95px]"
      />
    </>
  );
};
